var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightningStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.88997 6.87292L4.16272 12.8729C4.03793 13.0036 3.83957 13.0375 3.67686 12.9559C3.51416 12.8742 3.42663 12.6969 3.46249 12.5215L4.21246 8.8551L1.26546 7.77453C1.13757 7.72764 1.04205 7.62143 1.01083 7.49141C0.979616 7.36139 1.01683 7.22471 1.11003 7.12707L6.83728 1.12708C6.96207 0.996361 7.16042 0.962498 7.32314 1.04414C7.48584 1.12579 7.57336 1.3031 7.53751 1.47845L6.78754 5.1449L9.73454 6.22546C9.86244 6.27235 9.95795 6.37857 9.98917 6.50859C10.0204 6.63861 9.98317 6.77529 9.88997 6.87292Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningStroke);
export default __webpack_public_path__ + "static/media/lightning-stroke.b8fa63dc9f1c774ea00f9f66b4894490.svg";
export { ForwardRef as ReactComponent };